import { Page } from '../../Page';

export interface IPrimaryLabelParams {
  page: Page;
  isScheduledGame: boolean;
  isAutoTaggingEnabled: boolean;
}

export const shouldShowBackButton = (page: Page): boolean => page !== Page.GameType;

export const isFinalPage = (page: Page): boolean => page === Page.GameSettings;

export const getPrimaryButtonLabel = (params: IPrimaryLabelParams): string => {
  const { page, isScheduledGame, isAutoTaggingEnabled } = params;

  if (!isFinalPage(page)) {
    return isScheduledGame ? 'Confirm' : 'Next';
  }

  if (!isScheduledGame) {
    return 'Create and set lineup';
  }

  return isAutoTaggingEnabled ? 'Start auto-tagging' : 'Confirm and set lineup';
};
